/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
export default function ChangePasswordController($scope, $translate, toast, $mdDialog, loginService) {
    var vm = this;

    vm.currentPassword = '';
    vm.newPassword = '';
    vm.newPassword2 = '';

    vm.cancel = cancel;
    vm.changePassword = changePassword;

    function cancel() {
        $mdDialog.cancel();
    }

    function changePassword() {
        if (vm.newPassword !== vm.newPassword2) {
            toast.showError($translate.instant('login.passwords-mismatch-error'));
        } else {
            loginService.changePassword(vm.currentPassword, vm.newPassword).then(function success() {
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/profile/change-password.controller.js